<div id="simpleLayout" class="simple-layout-page-wrapper">
    <app-header></app-header>
    <div class="simple-layout-content-wrapper">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>

